import { MenuIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from "@/components/ui/sheet";

import { SidebarContent } from "./sidebar";

interface MobileNavProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Menu button (below lg) that opens the sidebar navigation in a sheet. On phones the tab bar's More opens
 * the same sheet, and this button steps aside (`data-drawer-button`, components/assets/css/pwa.css).
 */
export function MobileNav({ open, onOpenChange }: MobileNavProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetTrigger asChild>
        <Button
          variant="ghost"
          size="icon-sm"
          className="-ml-1.5 lg:hidden"
          aria-label="Open navigation"
          data-drawer-button
        >
          <MenuIcon />
        </Button>
      </SheetTrigger>
      <SheetContent
        side="left"
        className="gap-0 overflow-hidden bg-sidebar p-0 text-sidebar-foreground"
        aria-describedby={undefined}
        data-app-sidebar
      >
        <SheetTitle className="sr-only">Navigation</SheetTitle>
        <SidebarContent onNavigate={() => onOpenChange(false)} />
      </SheetContent>
    </Sheet>
  );
}
